import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Subject } from "rxjs";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { PessoaService } from "../pessoa/pessoa.service";
import { SessionService } from "../session/session.service";
import { HeaderService } from "./../http/header.service";

@Injectable()
export class AceiteTermoPrivacidadeService {
  constructor(
    private http: Http,
    private HeaderService: HeaderService,
    private PessoaService: PessoaService,
    private SessionService: SessionService
  ) {}

  atualizaAceite(isAtualiza: number) {
    const headers = this.HeaderService.getHeadersGnx();
    const pesCod = this.PessoaService.getPessoa().pes_cod_comp;

    return this.http
      .post(
        environment.apiGxUrl + "/wsaceitepessoa.svc/rest/",
        {
          PesCod: pesCod,
          TipAceCod: 1,
          isAtualiza: isAtualiza,
        },
        { headers: headers }
      )
      .map((res) => res.json())
      .catch((err: any) => {
        return Observable.throw(new Error(err.json()));
      });
  }

  getAceiteUsuario() {
    return this.atualizaAceite(0);
  }

  putAceiteUsuario() {
    if (this.SessionService.getValor("salvaAceite") === "true") {
      this.SessionService.setValor("salvaAceite", "false");
      return this.atualizaAceite(1);
    } else {
      return new Subject().asObservable();
    }
  }

  putSalvarAceiteUsuario() {
    this.SessionService.setValor("salvaAceite", "true");
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/aceite-termo-privacidade/aceite-termo-privacidade.service.ts